export enum ThemeEnum {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}

export const THEME_STORAGE_KEY = 'quickchat-ui-theme';
